import { useQueries } from "@tanstack/react-query";
import { callApi, HttpMethod } from "src/services/apiService";
import { TC } from "../utils/trustCallApi";
import type {
  ServiceTypeSummary,
  CarrierTrendData,
  ScoreSummaryItem,
  FlagsRemovedByCarrier,
} from "../types";

export function useDashboardMetrics() {
  const results = useQueries({
    queries: [
      {
        queryKey: ["trustcall", "dashboard", "service-type-summary"],
        queryFn: (): Promise<ServiceTypeSummary> =>
          callApi(TC.DASHBOARD_SERVICE_TYPE, HttpMethod.GET),
      },
      {
        queryKey: ["trustcall", "dashboard", "score-summary"],
        queryFn: (): Promise<ScoreSummaryItem[]> =>
          callApi(TC.DASHBOARD_SCORE_SUMMARY, HttpMethod.GET),
      },
      {
        queryKey: ["trustcall", "dashboard", "score-summary-max"],
        queryFn: (): Promise<ScoreSummaryItem[]> =>
          callApi(`${TC.DASHBOARD_SCORE_SUMMARY}?isMaxScamScore=true`, HttpMethod.GET),
      },
      {
        queryKey: ["trustcall", "dashboard", "flagged-type-summary"],
        queryFn: (): Promise<ScoreSummaryItem[]> =>
          callApi(TC.DASHBOARD_FLAGGED_SUMMARY, HttpMethod.GET),
      },
      {
        queryKey: ["trustcall", "dashboard", "carriers-flagged"],
        queryFn: (): Promise<CarrierTrendData> =>
          callApi(TC.DASHBOARD_CARRIERS_FLAGGED, HttpMethod.GET),
      },
      {
        queryKey: ["trustcall", "dashboard", "clean-numbers-count"],
        queryFn: (): Promise<{ cleanNumbersCount: number }> =>
          callApi(TC.DASHBOARD_CLEAN_COUNT, HttpMethod.GET),
      },
      {
        queryKey: ["trustcall", "dashboard", "ftc-flagged-count"],
        queryFn: (): Promise<{ ftcFlaggedCount: number }> =>
          callApi(TC.DASHBOARD_FTC_COUNT, HttpMethod.GET),
      },
      {
        queryKey: ["trustcall", "dashboard", "flags-removed-count"],
        queryFn: (): Promise<{ carriers: FlagsRemovedByCarrier[] }> =>
          callApi(TC.DASHBOARD_FLAGS_REMOVED, HttpMethod.GET),
      },
    ],
  });

  const [
    serviceTypeSummary,
    scoreSummary,
    maxScoreSummary,
    flaggedTypeSummary,
    carriersFlagged,
    cleanCount,
    ftcCount,
    flagsRemoved,
  ] = results;

  const isLoading = results.some((r) => r.isLoading);
  const error = results.find((r) => r.error)?.error ?? null;

  return {
    serviceTypeSummary: serviceTypeSummary.data,
    scoreSummary: scoreSummary.data,
    maxScoreSummary: maxScoreSummary.data,
    flaggedTypeSummary: flaggedTypeSummary.data,
    carriersFlagged: carriersFlagged.data,
    cleanCount: cleanCount.data?.cleanNumbersCount,
    ftcCount: ftcCount.data?.ftcFlaggedCount,
    flagsRemoved: flagsRemoved.data?.carriers,
    isLoading,
    error,
  };
}
